module.exports = __webpack_public_path__ + "img/sand-decal-25.0a94a88a.png";